import { StateShortName } from '@acp/shared';

type FacetOption = {
    label: string;
    value: string;
    applicableStates: StateShortName[] | null;
};

const serviceOptions = [
    {
        label: 'Smoke Alarms',
        value: 'smoke',
        applicableStates: null,
    },
    {
        label: 'Electrical',
        value: 'electrical',
        applicableStates: [StateShortName.VIC],
    },
    {
        label: 'Gas',
        value: 'gas',
        applicableStates: [StateShortName.VIC],
    },
];

export {
    serviceOptions,
    FacetOption,
};
